var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAboutEllipseCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 296,
    height: 420,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 91,
    cy: 128,
    r: 91,
    fill: "#0B8B8B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M477 210c0 115.98-94.02 210-210 210S57 325.98 57 210 151.02 0 267 0s210 94.02 210 210Zm-333.443 0c0 68.176 55.267 123.443 123.443 123.443 68.176 0 123.443-55.267 123.443-123.443 0-68.176-55.267-123.443-123.443-123.443-68.176 0-123.443 55.267-123.443 123.443Z",
    fill: "#86CECE",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutEllipseCircle);
export default __webpack_public_path__ + "static/media/about_ellipse_circle.7348df35c7a4038c091dc20482b20d88.svg";
export { ForwardRef as ReactComponent };